// @ts-nocheck
import React from 'react'
import { Text, View, StyleSheet } from '@react-pdf/renderer'
import { BambiniIcon } from './icon'

interface Props {
  text?: string
  color?: string
  fontSizePercentage?: number
}

export const BambinoBanner: React.FC<Props> = ({ text, color, fontSizePercentage }) => {
  const bannerText = text?.trim()
  if (!bannerText) return <></>
  const FONT_SIZE_RATIO = fontSizePercentage || 100
  const adjustFontSize = (size) => `${(size * FONT_SIZE_RATIO) / 100}pt`

  const styles = StyleSheet.create({
    section: {
      width: '100%',
      marginBottom: '10px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      height: 45
    },
    text: {
      fontFamily: 'saa-e-d',
      fontSize: adjustFontSize(8),
      textTransform: 'uppercase',
      textAlign: 'center',
      marginTop: 5
    }
  })

  return (
    <View style={styles.section}>
      <View style={{ width: 33, height: 33, marginLeft: 'auto', marginRight: 'auto' }}>
        <BambiniIcon color={color} width={33} height={33} />
      </View>
      <Text style={styles.text}>{bannerText}</Text>
    </View>
  )
}
